import { NgModule, Pipe } from '@angular/core';
import {Configuration} from '../../../configuration';

@Pipe({
    name: 'imgSrcPrefix'
})
export class ImgSrcPrefixPipe {
    constructor(private readonly config: Configuration) { }

    transform(src: string) {
        return `${this.config.routing.basePath}${src}`;
    }
}

@NgModule({
    declarations: [ImgSrcPrefixPipe],
    exports: [ImgSrcPrefixPipe]
})
export class ImgSrcPrefixPipeModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/pipes/imgsrcprefix.pipe/img.src.pipe.module.ts